import statusTranslation from './statusTranslation'
import snackbarStatusTranslation from './snackbarStatusTranslation'

const technicalFaqs = {
  statusTranslation,
  snackbarStatusTranslation,
}

export default technicalFaqs
